// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__33bfd","errorLogs":"EditorFooter_errorLogs__3qdUG"};